const ADJUST_DATA = 'ADJUST_DATA';

export function getAdjustData(data) {
  return dispatch => {
    dispatch({
      type: ADJUST_DATA,
      data: {
        ...data,
      },
    });
  };
}

export function adjustData(state = {}, action) {
  switch (action.type) {
    case ADJUST_DATA:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/finance/budget/adjust_data.js